function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import BasicUtils from "../../utils/basic-utils";
import Icon from "../elements/icon";

var ToastAlert = /*#__PURE__*/function (_React$Component) {
  _inherits(ToastAlert, _React$Component);

  var _super = _createSuper(ToastAlert);

  function ToastAlert() {
    var _this;

    _classCallCheck(this, ToastAlert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      animation: "in"
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      if (_.isFunction(_this.props.onClose)) {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleUndo", function () {
      if (_.isFunction(_this.props.onUndo)) {
        _this.props.onUndo();

        _this.handleClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleAction", function () {
      if (_.isFunction(_this.props.onAction)) {
        _this.props.onAction();

        _this.handleClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
      return _.map(BasicUtils.makeArray(_this.props.children), function (child, index) {
        if (child.type) {
          return /*#__PURE__*/React.cloneElement(child, {
            key: index,
            onToastClose: _this.handleClose
          });
        } else {
          return child;
        }
      });
    });

    return _this;
  }

  _createClass(ToastAlert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.timeout) {
        _.delay(function () {
          return _this2.handleClose();
        }, this.props.timeout);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if (newProps.willBeRemoved) {
        this.setState({
          animation: "out"
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var toastClasses = classNames(this.props.className, {
        "et--toast": true,
        "et--toast--success": this.props.type === "success",
        "et--toast--warning": this.props.type === "warning",
        "et--toast--error": this.props.type === "error",
        animated: true,
        fadeInRight: this.state.animation === "in",
        fadeOutUp: this.state.animation === "out"
      });
      var toastIcons = classNames(this.props.icon, {
        "et--toast--icon": true,
        "gt-icon": true,
        "gt-icon-access-time": !this.props.icon && this.props.type === "info",
        "gt-icon-check-circle": !this.props.icon && this.props.type === "success",
        "gt-icon-cancel": !this.props.icon && this.props.type === "warning",
        "gt-icon-alert-circle": !this.props.icon && this.props.type === "error"
      });
      return /*#__PURE__*/React.createElement("div", {
        className: toastClasses
      }, /*#__PURE__*/React.createElement("i", {
        className: toastIcons
      }), this.props.header ? /*#__PURE__*/React.createElement("div", {
        className: "et--toast--message"
      }, /*#__PURE__*/React.createElement("div", {
        className: "et--toast--header"
      }, this.props.header), /*#__PURE__*/React.createElement("div", {
        className: "et--toast--body"
      }, this.renderChildren())) : /*#__PURE__*/React.createElement("div", {
        className: "et--toast--message"
      }, this.renderChildren()), (this.props.onAction || this.props.onUndo) && /*#__PURE__*/React.createElement("div", {
        className: "et--toast--actions"
      }, this.props.onAction && /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: this.handleAction
      }, this.props.actionLabel), this.props.onUndo && /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: this.handleUndo
      }, "Undo")), /*#__PURE__*/React.createElement(Icon, {
        className: "et--toast--close",
        icon: "close",
        onClick: this.handleClose
      }));
    }
  }]);

  return ToastAlert;
}(React.Component);

_defineProperty(ToastAlert, "displayName", "ToastAlert");

_defineProperty(ToastAlert, "propTypes", {
  type: PropTypes.string,
  timeout: PropTypes.number,
  actionLabel: PropTypes.string,
  willBeRemoved: PropTypes.bool,
  icon: PropTypes.string,
  header: PropTypes.string,
  onAction: PropTypes.func,
  onClose: PropTypes.func,
  onUndo: PropTypes.func
});

export { ToastAlert as default };